import { render } from "./AddressForm.vue?vue&type=template&id=47aa19c9&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"

import "./AddressForm.vue?vue&type=style&index=0&id=47aa19c9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47aa19c9"]])

export default __exports__